<script>
// Esqueleto con la forma final del dashboard (sin shimmer, sin degradado).
export default { name: "DashSkeleton" };
</script>

<template>
  <div class="dsh-grid dsh-skel" role="status" aria-live="polite" aria-label="Cargando el cumplimiento del SG-SST">
    <section class="dsh-panel dsh-b1">
      <div class="dsh-skel__bar dsh-skel__bar--title"></div>
      <div class="dsh-skel__wheelrow">
        <div class="dsh-skel__ring"></div>
        <div class="dsh-skel__rows">
          <div v-for="n in 4" :key="n" class="dsh-skel__bar"></div>
        </div>
      </div>
    </section>
    <section class="dsh-panel dsh-b2">
      <div class="dsh-skel__bar dsh-skel__bar--title"></div>
      <div v-for="n in 5" :key="n" class="dsh-skel__bar dsh-skel__bar--row"></div>
    </section>
    <section class="dsh-panel dsh-b3">
      <div class="dsh-skel__bar dsh-skel__bar--title"></div>
      <div v-for="n in 7" :key="n" class="dsh-skel__bar dsh-skel__bar--thin"></div>
    </section>
    <section class="dsh-panel dsh-b4">
      <div class="dsh-skel__bar dsh-skel__bar--title"></div>
      <div class="dsh-skel__bar dsh-skel__bar--block"></div>
    </section>
  </div>
</template>
